import { Headphones, User, FileText, DollarSign, Users, MessageCircle, Puzzle } from "lucide-react";

export const SOLUTION_ICON_MAP = {
  headphones: Headphones,
  user: User,
  "file-text": FileText,
  "dollar-sign": DollarSign,
  users: Users,
  "message-circle": MessageCircle,
};

export const getSolutionIcon = (icon) => SOLUTION_ICON_MAP[icon] || Puzzle;
